var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislike2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4473 9.29974L11.7193 7.72684C11.7872 7.33398 11.4851 6.97465 11.0868 6.97465H9.08934C8.89136 6.97465 8.7406 6.79695 8.77265 6.60137L9.02814 5.04203C9.06964 4.7887 9.05779 4.52949 8.99333 4.28102C8.93994 4.07519 8.78113 3.90991 8.57228 3.84281L8.51639 3.82486C8.39017 3.78431 8.2524 3.79375 8.1334 3.85109C8.00241 3.91421 7.90658 4.02934 7.87106 4.16627L7.68766 4.87329C7.6293 5.09825 7.5443 5.31539 7.4347 5.52056C7.27457 5.82034 7.02698 6.06026 6.76962 6.28203L6.21493 6.76002C6.05854 6.89479 5.9764 7.09662 5.9942 7.30244L6.30732 10.9237C6.33604 11.2558 6.61374 11.5108 6.94676 11.5108H8.73899C10.0812 11.5108 11.2266 10.5757 11.4473 9.29974Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77669 6.68584C4.93139 6.67916 5.06389 6.79554 5.07723 6.94981L5.45182 11.2819C5.47588 11.5602 5.25669 11.8 4.9768 11.8C4.71316 11.8 4.5 11.5862 4.5 11.323V6.97472C4.5 6.81987 4.62198 6.69251 4.77669 6.68584Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike2);
export default __webpack_public_path__ + "static/media/dislike2.558d1e3455f5df31aead632785cc6b08.svg";
export { ForwardRef as ReactComponent };